
export default {
    data(){
        return {
            sysTheme:sessionStorage.getItem('sysTheme')||'orange',
            settings:{}
        }
    },
    methods: {
        getSettings(){
            console.log('request getSetting------')

            let that = this
            let params = that.$utils.getMainUrlParam(2)
            let hash=this.$utils.getMainUrlHash()
            let url=this.$api.API_InfomationQuery+(hash?'?hashtag='+hash:'')

            let promise = new Promise(function(resolve, reject){
                that.$http
                .post(url, that.$qs.stringify(params))
                .then(res => { 
                  if (res.success) {
                    console.log('request getSetting success------')   
                   that.settings=res.data[0]
                   resolve(that.settings)
                 
                  }
                })
                .catch(err => {
                    reject(err)
                    console.log('request getSetting error------')
                })        
            })

            return promise 
        },
        getJsApiCfg(){
            console.log('request JsApiCfg------')

            let that = this    
            let hash=this.$utils.getMainUrlHash()
            let currentUrl=encodeURI(window.location)
            let url=this.$api.API_JsApiCfgQuery+'?url='+(currentUrl)

            let params = that.$utils.getMainUrlParam(2)
            params.url=currentUrl

            let promise = new Promise(function(resolve, reject){
                that.$http
                .get(url, that.$qs.stringify(params))
                .then(res => { 
                  if (res.success) {
                   console.log('request JsApiCfg success------')   
  
                   resolve(res.data[0])
                 
                  }
                })
                .catch(err => {
                    reject(err)
                    console.log('request JsApiCfg error------')
                })        
            })

            return promise 
        },
        setSysTheme(themeName){       
            this.sysTheme=themeName||this.sysTheme
            sessionStorage.setItem('sysTheme', this.sysTheme)
        },
        setLocalData(dataName,data){
            if(dataName&&data){
                let cp= this.$utils.getParameterValues("cp");
                let saveKey=`${cp}_${dataName}`
                let saveData=JSON.stringify(data);
                localStorage.setItem(saveKey, saveData)
            }
     
        },
        getLocalData(dataName){
            if(dataName){
                let cp= this.$utils.getParameterValues("cp");
                let saveKey=`${cp}_${dataName}`
                
                let saveData= localStorage.getItem(saveKey)         
                let data =this.$utils.isObject(saveData)?JSON.parse(saveData):saveData
                return data
            }
          
        }
    },  
    created() {     

    },
  }

